module.exports = __webpack_public_path__ + "static/dra-vianka-torres-logos-bdc3c09fde7b0711be135a57f64cfe7f.svg";